// global module table
export const bbjModuleId = 'f595fd2c-e029-11eb-a7b4-ace2d34b68ef';
export const ahjvModuleId = 'f595f5f4-e029-11eb-a7b4-ace2d34b68ef';
export const srfpModuleId = 'f5960487-e029-11eb-a7b4-ace2d34b68ef';
export const onboardingModuleId = 'f5960107-e029-11eb-a7b4-ace2d34b68ef';
export const dashboardModuleId = 'f595ff7c-e029-11eb-a7b4-ace2d34b68ef';

// They are the same as settings
export const settingProgramAdminModuleId =
  'f5960485-e029-11eb-a7b4-ace2d34b68ef';
export const settingContarctAdminModuleId =
  'f5960486-e029-11eb-a7b4-ace2d34b68ef';

// module table
export const docModuleId = '9c012357-0baf-11ea-917a-027e1b1809fa';
export const settingModuleId = '8c0123b4-0baf-11ea-917a-027e1b1809fa';

// global application table
export const costAppId = '8a013205-0baf-11ea-917a-027e1b1809bd';
export const settingAppId = '8a011294-0baf-11ea-917a-027e1b1809fa';

// application table
export const correspondenceAppId = '8a011297-0baf-11ea-917a-027e1b1809fa';

// active directory role
export const globalAdmin = 'BBJ-Program_Admin';
export const contract_DDC_Admin = 'DDC_Admin';
export const contract_AHJV_Admin = 'AHJV_Admin';

export const onboardingGroupId = "4ca498d3-6d60-45c5-948d-6aaaa7114a00";